import { render, staticRenderFns } from "./subjectList.vue?vue&type=template&id=b787666c"
import script from "./subjectList.vue?vue&type=script&lang=js"
export * from "./subjectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports